var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.imovel != null
    ? _c(
        "li",
        {
          on: {
            mouseover: function($event) {
              return _vm.$emit("mouseover")
            },
            mouseleave: function($event) {
              return _vm.$emit("mouseleave")
            }
          }
        },
        [
          _c("div", [
            _c(
              "a",
              {
                staticClass: "wrap-link",
                attrs: { href: _vm.url, target: "_blank" }
              },
              [
                _c(
                  "figure",
                  {
                    staticClass: "image is-3by2",
                    style: "background-image: url(" + _vm.imagem_url + ");"
                  },
                  [
                    _c("img", {
                      attrs: { src: "static/images/480x320.png", alt: "" }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.tipo))]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "labels" },
                      _vm._l(_vm.flags, function(flag) {
                        return _c(
                          "li",
                          {
                            key: flag.id,
                            style: { "background-color": flag.cor }
                          },
                          [_vm._v(_vm._s(flag.titulo))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "selos" },
                      _vm._l(_vm.selos, function(selo) {
                        return _c("li", { key: selo.id }, [
                          _c("img", { attrs: { src: "_files/" + selo.imagem } })
                        ])
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { "min-height": "68px" } }, [
                  _vm.empreendimento != ""
                    ? _c(
                        "p",
                        {
                          staticClass: "location",
                          staticStyle: { "margin-bottom": "auto" }
                        },
                        [_vm._v(_vm._s(_vm.empreendimento))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.bairro))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "location" }, [
                    _c("img", {
                      attrs: { src: "static/images/pin.png", alt: "" }
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.cidade) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.tem_placa
                    ? _c("p", [
                        _vm._v(
                          "\n                    Placa: " +
                            _vm._s(_vm.tem_placa == "Sim" ? "Sim" : "Não") +
                            "\n                "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.observacoes && _vm.observacoes != ""
                    ? _c("p", [
                        _vm._v(
                          "\n                    Obs: " +
                            _vm._s(_vm.observacoes) +
                            "\n                "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.valor != 0.0
                  ? _c("p", { staticClass: "price" }, [
                      _vm._v(
                        "R$" +
                          _vm._s(
                            _vm._f("number_format")(_vm.valor, 2, ",", ".")
                          )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "small-block-grid-1 medium-block-grid-2 infos"
                  },
                  [
                    _c("li", [
                      _c("img", {
                        attrs: { src: "static/images/bed.png", alt: "" }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.dormitorios) +
                          " Dorm.\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("img", {
                        attrs: { src: "static/images/car.png", alt: "" }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.vagas) +
                          " Vaga" +
                          _vm._s(_vm.vagas != 1 ? "s" : "") +
                          "\n                "
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }